// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3odW_","header":"PatientBlock_header__1eJMI","label":"PatientBlock_label__3FAnl","option":"PatientBlock_option__3LSz6"};